// 设置token
export const setToken = (key, value) => {
  sessionStorage.setItem(key, value)
}

// 获取token
export const getToken = (key) => {
  return sessionStorage.getItem(key)
}

//卫星拍摄
export const defaultModelId = 'ce0d06c3-aaa7-4749-89ac-252f134b8f6a'
export const modelIds = ['ce0d06c3-aaa7-4749-89ac-252f134b8f6a','ce0d06c3-aaa7-7449-98ac-jdhen83jh47d']